<template>
  <div id="app">
    <router-view @login="loginDirect" />
  </div>
</template>

<script>
import localRouter from '@/router/fullPath.js';
import baseRouter from '@/router/index.js';

export default {
  created() {
    // if (this.$route.path !== '/' && this.$route.path !== '/login') {
    //   this.signin();
    // }
    this.checkToken();
  },
  methods: {
    checkToken() {
      this.$api.global.checkToken().then((res) => {
        if (res.direct) {
          this.loginDirect();
        } else {
          this.$store.commit('loginOut');
          if (this.$route.path !== '/' && this.$route.path !== '/login') {
            this.$router.replace({path: '/login'});
          }
        }
      });
    },
    loginDirect(newPath) {
      this.signin(() => {
        if (this.$route.path === '/login') {
          if(!newPath) {
            const list = this.$router.options.routes[1].children.filter(item => !item.menuHidden);
            this.$router.push({name: list[0].name}).catch(() => true)
          } else {
            this.$router.replace({path: newPath}).catch(() => true);
          }
        }
      });
    },
    signin(callBack) {
      this.$api.global.treeList().then(res => {
        if (res.childNode) {
          this.extendRoutes(res.childNode);
          callBack && callBack();
        }
      })
    },
    extendRoutes(severRouter) {
      console.log("***************"+severRouter)
      const findLocalRoute = (server, local) => {
        const array = [];
        // 加入隐藏的本地路由路径
        local.forEach(item => {
          if (item.menuHidden) array.push(item);
        })
        server.forEach(item => {
          if(Array.isArray(local)) {
            const localItem = local.find(it => (item.name === it.label && item.open));
            if (localItem) {
              if(localItem.children) {
                localItem.children = findLocalRoute(item.childNode, localItem.children);
              }
              array.push(localItem);
            }
          }
        });
        return array;
      };
      const router = findLocalRoute(severRouter, localRouter);
      if (this.$router.options.routes.length > 5) return;
      const routerOptions = router.concat(this.$router.options.routes);
      this.$router.options.routes = routerOptions;
      this.$router.addRoutes(router);
    },
  },
};

</script>

<style lang="scss">
@import './styles/init.scss';
@import './styles/commonModel.scss';
</style>
